module.exports = (__webpack_require__(2))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./src/rest.js from dll-reference girder_plugin_slicer_cli_web
// module id = 4
// module chunks = 0